import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Spinner } from 'react-bootstrap';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import { Pie } from 'react-chartjs-2';
import { ProductContext } from '../context/AppContext';
import "./NewLearningJourney.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { Modal, Tab, Tabs } from "react-bootstrap";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend
} from 'chart.js';
import FooterNav from './Common_Components/FooterNav';
import axios from 'axios';
import "../index.css";
import translations from './translation';
import { io } from "socket.io-client";
ChartJS.register(ArcElement, Tooltip, Legend);

function Home() {

  const AuthToken1 = localStorage.getItem("AuthToken");

  const navigate = useNavigate();
  const [selectedLanguage, setSelectedLanguage] = useState('');
  useEffect(() => {
    const storedLanguage = localStorage.getItem("selectedLanguage");
    setSelectedLanguage(storedLanguage || "english");
  }, []);
  const homeText = translations[selectedLanguage === "hindi" ? "hindi" : "english"];
  const { username } = useContext(ProductContext);
  const { totalHours } = useContext(ProductContext);
  const { totalMinutes } = useContext(ProductContext);
  console.log(username, "username Home")
  const { Leveldata } = useContext(ProductContext);
  const { examTypes } = useContext(ProductContext);
  const { ExamTypedata } = useContext(ProductContext);
  console.log(Leveldata, "Leveldata")
  // const SelectLanguageLocal = localStorage.getItem("selectedLanguage");
  // console.log(SelectLanguageLocal, "SelectLanguageLocal")
  const completedHours = totalHours + totalMinutes / 60;
  const percentageCompleted = (completedHours / 350) * 100;
  console.log("khjjbjbjbbhjj", completedHours);
  const authToken = localStorage.getItem('AuthToken');
  console.log("authToken:", authToken);
  const { Translate, VisitedCountData,
    setVisitedCountData,
    marker,
    setMarker,
    selectedExamId, setSelectedExamId, ExamLevelId } = useContext(ProductContext);
  console.log("ExamLevelId", ExamLevelId);
  // const data = {
  //   datasets: [
  //     {
  //       data: [percentageCompleted, 100 - percentageCompleted],
  //       backgroundColor: ["orange", "white"],
  //       borderWidth: 0,
  //     },
  //   ],
  // };
  const widthAndHeight = 160;
  // const totalGoal = VisitedCountData?.message?.totalCount;
  const totalGoal = VisitedCountData?.message?.totalCount || 100;

  const totalHours1 = VisitedCountData?.message?.count;
  const totalMinutes1 = totalMinutes;
  const circleData = [
    {
      title: 'JLPT N5',
      index: 0,
      totalHours: totalHours1,
      totalMinutes: totalMinutes1,
      series: [totalHours1, totalGoal - totalHours1],
      sliceColor: ['#fdbe44', '#f0f0f0'],
    },
    {
      title: 'JLPT N4',
      index: 1,
      totalHours: totalHours1,
      totalMinutes: totalMinutes1,
      series: [totalHours1, totalGoal - totalHours1],
      sliceColor: ['#fdbe44', '#f0f0f0'],
    },
    {
      title: 'JLPT N3',
      index: 2,
      totalHours: totalHours1,
      totalMinutes: totalMinutes1,
      series: [totalHours1, totalGoal - totalHours1],
      sliceColor: ['#fdbe44', '#f0f0f0'],
    },
    {
      title: 'JLPT N2',
      index: 3,
      totalHours: totalHours1,
      totalMinutes: totalMinutes1,
      series: [totalHours1, totalGoal - totalHours1],
      sliceColor: ['#fdbe44', '#f0f0f0'],
    },
    {
      title: 'JLPT N1',
      index: 4,
      totalHours: totalHours1,
      totalMinutes: totalMinutes1,
      series: [totalHours1, totalGoal - totalHours1],
      sliceColor: ['#fdbe44', '#f0f0f0'],
    },
  ];
  const data = {
    datasets: [
      {
        title: 'JLPT N5',
        index: 0,
        totalHours: totalHours1,
        totalMinutes: totalMinutes1,
        data: [totalHours1, totalGoal - totalHours1],
        backgroundColor: ["orange", "white"],
        borderWidth: 0,
      },

    ],
  };
  const [updateData, setUpdateData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [homeLoading, setHomeLoading] = useState(true);
  const [latestVisitData, setLatestVisitData] = useState(null);
  const [nextSectionData, setNextSectionData] = useState(null);
  const [examDays, setExamDays] = useState([]);
  const [homeLessonLabel, setHomeLessonLabel] = useState("");
  const [homeSectionLabel, setHomeSectionLabel] = useState("");
  const [latestGroupMessage, setLatestGroupMessage] = useState(null);

  const storedUser = React.useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem("user") || "{}");
    } catch {
      return {};
    }
  }, []);

  const senderId = username?.message?.userDetails?.user_id || storedUser?.user_id || "";
  const hours = Math.floor(completedHours);
  const minutes = Math.round((completedHours - hours) * 60);
  const formattedHours = hours > 0 ? `${hours}h` : "";
  const formattedMinutes = minutes > 0 ? `${minutes}m` : "";
  const overlayText = `${formattedHours} ${formattedMinutes}`.trim();
  // const [ExamTypedata, setExamTypedata] = useState();
  // const [levelData, setLevelData] = useState([]);
  // const [language, setLanguage] = useState('english');
  // const [examTypes, setExamTypes] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [activeTab, setActiveTab] = useState("N5");
  const [selectedTab, setSelectedTab] = useState("N5");
  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  const handleTabChange = (key) => setActiveTab(key);
  const [error, setError] = useState(null);
  // const [selectedLanguage, setSelectedLanguage] = useState('');


  const handleStartJourney = (examId, examTypes) => {
    navigate('/learning-journey', {
      state: {
        examId,
        examTypes,
        selectedExamId,
        selectedExamType,
        selectedExamId_New

      },
    });
  };
  const handleStartJourneyLogin = () => {
    navigate('/login');
  }
  const [selectedExamType, setSelectedExamType] = useState(null);
  const apiBaseUrl = process.env.REACT_APP_BASE_URL || "https://api.japaking.online";
  const localApiBaseUrl = `${apiBaseUrl}/api`;
  const localHostApiBaseUrl = "https://api.japaking.online/api";

  const parseLearningModules = () => {
    try {
      const storedModules = localStorage.getItem("LearningDataLocal");
      const parsedModules = storedModules ? JSON.parse(storedModules) : [];
      return Array.isArray(parsedModules) ? parsedModules : [];
    } catch (error) {
      console.error("Failed to read stored learning modules:", error);
      return [];
    }
  };

  const sortLearningModules = (modules = []) => [...modules].sort((a, b) => {
    const ponoDiff = Number(a?.pono || 0) - Number(b?.pono || 0);
    if (ponoDiff !== 0) {
      return ponoDiff;
    }

    const dayA = parseInt(String(a?.day_name || "").replace("Lesson", "").trim(), 10);
    const dayB = parseInt(String(b?.day_name || "").replace("Lesson", "").trim(), 10);

    if (Number.isNaN(dayA) && Number.isNaN(dayB)) {
      return 0;
    }
    if (Number.isNaN(dayA)) {
      return 1;
    }
    if (Number.isNaN(dayB)) {
      return -1;
    }
    return dayA - dayB;
  });

  const formatLessonLabel = (value) => {
    const lessonNumber = Number(value);
    if (lessonNumber <= 0) {
      return "";
    }
    return `${isHindiLanguage ? "पाठ" : "Lesson"} ${lessonNumber}`;
  };

  const localizeLessonText = (value) => {
    const text = String(value || "").trim();
    if (!text) {
      return "";
    }

    if (isHindiLanguage) {
      return text.replace(/^(Lesson|पाठ)\s*(\d+)/i, "पाठ $2");
    }

    return text.replace(/^(Lesson|पाठ)\s*(\d+)/i, "Lesson $2");
  };

  const localizeSectionText = (value) => {
    const text = String(value || "").trim();
    if (!text) {
      return "";
    }

    const strippedText = text.replace(
      /^(?:Lesson|Section|पाठ|हिस्सा)\s*\d+\s*-\s*/i,
      ""
    );

    if (isHindiLanguage) {
      return strippedText.replace(/^(?:Lesson|Section|पाठ|हिस्सा)\s*(\d+)/i, "हिस्सा $1");
    }

    return strippedText.replace(/^(?:Lesson|Section|पाठ|हिस्सा)\s*(\d+)/i, "Section $1");
  };

  const resolveLessonNameByModuleId = (moduleId, fallback = "") => {
    const numericModuleId = Number(moduleId);
    if (!numericModuleId) {
      return fallback || "";
    }

    const matchedDay = examDays.find(
      (day) =>
        Number(day?.day_id) === numericModuleId ||
        Number(day?.id) === numericModuleId
    );

    return matchedDay?.day_name || fallback || formatLessonLabel(numericModuleId);
  };

  const resolveDayRecordByModuleId = (moduleId) => {
    const numericModuleId = Number(moduleId);
    if (!numericModuleId) {
      return null;
    }

    return (
      examDays.find(
        (day) =>
          Number(day?.id) === numericModuleId ||
          Number(day?.day_id) === numericModuleId
      ) || null
    );
  };

  const resolveNextDayRecordByModuleId = (moduleId) => {
    const numericModuleId = Number(moduleId);
    if (!numericModuleId) {
      return null;
    }

    const orderedDays = [...examDays].sort((a, b) => {
      const ponoDiff = Number(a?.pono || 0) - Number(b?.pono || 0);
      if (ponoDiff !== 0) {
        return ponoDiff;
      }
      return Number(a?.id || 0) - Number(b?.id || 0);
    });

    const currentIndex = orderedDays.findIndex(
      (day) =>
        Number(day?.id) === numericModuleId ||
        Number(day?.day_id) === numericModuleId
    );

    if (currentIndex !== -1 && currentIndex + 1 < orderedDays.length) {
      return orderedDays[currentIndex + 1];
    }

    return null;
  };

  const fetchLearningMethodsForDayRow = async (dayRowId) => {
    if (!dayRowId) {
      return [];
    }

    try {
      const headers = {
        Authorization: `Bearer ${authToken}`,
        "Content-Type": "application/json",
      };
      const requestedDayId = Number(dayRowId);
      const response = await axios.get(
        `${localApiBaseUrl}/learning-method/${requestedDayId}`,
        { headers }
      );
      const learningMethods = response?.data?.message?.learningMethods || [];
      const canonicalDayId = Number(learningMethods?.[0]?.day_id || 0);

      if (canonicalDayId && canonicalDayId !== requestedDayId) {
        const canonicalResponse = await axios.get(
          `${localApiBaseUrl}/learning-method/${canonicalDayId}`,
          { headers }
        );
        return canonicalResponse?.data?.message?.learningMethods || learningMethods;
      }

      return learningMethods;
    } catch (error) {
      console.error("Failed to fetch learning methods for day row:", error);
      return [];
    }
  };

  const storedLearningModules = sortLearningModules(parseLearningModules());
  const storedCurrentModuleId = Number(localStorage.getItem("LearningJourneyActiveModuleId"));
  const storedCurrentModuleByDayId = storedLearningModules.find(
    (module) => Number(module?.day_id) === storedCurrentModuleId
  );
  const storedCurrentModule =
    storedCurrentModuleByDayId ||
    storedLearningModules.find((module) => Number(module?.id) === storedCurrentModuleId) ||
    storedLearningModules[0] ||
    null;
  const isHindiLanguage = selectedLanguage === "hindi";

  const syncActiveModule = (module) => {
    if (!module) {
      return;
    }

    const activeModuleKey = module.day_id ?? module.id;

    localStorage.setItem("LearningJourneyActiveModuleId", String(activeModuleKey));
    localStorage.setItem("LearningJourneyActiveModuleName", module.day_name || "");
    localStorage.setItem("ModuleId", String(activeModuleKey));
    localStorage.setItem("ModuleNameName", module.day_name || "");
    localStorage.setItem("examId", String(currentExamId));
  };

  const navigateToLearningJourney = (extraState = {}) => {
    navigate('/learning-journey', {
      state: {
        examId: navigationExamId,
        examTypes: ExamTypedata?.examTypes || [],
        selectedExamId: navigationExamId,
        selectedExamId_New: navigationExamId,
        selectedExamType: navigationExamType,
        ...extraState,
      },
    });
  };

  const composeSectionLabel = (lesson, method, screenTitle) => {
    const lessonPart = localizeLessonText(lesson);
    const methodPart = String(method || "").trim();
    const screenPart = String(screenTitle || "").trim();

    const combinedMethod = [methodPart, screenPart].filter(Boolean).join(" - ");
    if (lessonPart && combinedMethod) {
      return `${lessonPart} - ${combinedMethod}`.trim();
    }
    if (lessonPart) {
      return lessonPart;
    }
    return combinedMethod || screenPart || methodPart || "";
  };

  const persistCurrentSection = ({
    moduleId,
    lessonName,
    learningMethodId,
    screenTitleId,
  }) => {
    if (moduleId) {
      localStorage.setItem("LearningJourneyActiveModuleId", String(moduleId));
      localStorage.setItem("ModuleId", String(moduleId));
    }
    if (lessonName) {
      localStorage.setItem("LearningJourneyActiveModuleName", lessonName);
      localStorage.setItem("ModuleNameName", lessonName);
    }
    if (learningMethodId) {
      localStorage.setItem("LearningJourneyActiveLearningMethodId", String(learningMethodId));
      localStorage.setItem("LearningId", String(learningMethodId));
      localStorage.setItem("day_learning_method_id", String(learningMethodId));
    }
    if (screenTitleId) {
      localStorage.setItem("LearningJourneyActiveScreenId", String(screenTitleId));
      localStorage.setItem("screenTitleId", String(screenTitleId));
    }
    if (currentExamId) {
      localStorage.setItem("selectedExamId", String(currentExamId));
    }
  };

  const buildSectionState = ({
    moduleId,
    lessonName,
    learningMethod,
    screenTitle,
  }) => {
    const learningMethodId = learningMethod?.learning_method_id || null;
    const dayId = learningMethod?.day_id || moduleId || null;
    const screenCategoryId = screenTitle?.category_id || null;

    return {
      categoryId: screenCategoryId,
      dayId,
      unique_day_id: moduleId,
      LearningId: learningMethodId,
      day_learning_method_id: learningMethod?.day_learning_method_id || learningMethodId,
      dayName: lessonName || learningMethod?.method_type || `Lesson ${dayId || ""}`,
      examId: currentExamId,
      examTypes: ExamTypedata?.examTypes || [],
      selectedExamId: currentExamId,
      exams: ExamTypedata?.examTypes || [],
      methodType: learningMethod?.method_type || "",
      is_review: screenTitle?.is_review || false,
      categoryName: screenTitle?.subtitle || learningMethod?.desc || "",
      screenTitleId: screenTitle?.screen_title_id || null,
    };
  };

  const resolveScreenTitle = async (learningMethodId, screenTitleId) => {
    if (!learningMethodId) {
      return null;
    }

    try {
      const headers = {
        Authorization: `Bearer ${authToken}`,
        "Content-Type": "application/json",
      };
      const response = await axios.get(
        `${localApiBaseUrl}/screen-title/${learningMethodId}`,
        { headers }
      );
      const screenTitles = response?.data?.message?.screenTitle || [];
      if (screenTitleId) {
        return (
          screenTitles.find(
            (screen) => Number(screen.screen_title_id) === Number(screenTitleId)
          ) || screenTitles[0] || null
        );
      }
      return screenTitles[0] || null;
    } catch (error) {
      console.error("Failed to resolve screen title:", error);
      return null;
    }
  };

  const resolveNextScreenTitle = async (learningMethodId, currentScreenTitleId) => {
    if (!learningMethodId) {
      return null;
    }

    try {
      const headers = {
        Authorization: `Bearer ${authToken}`,
        "Content-Type": "application/json",
      };
      const response = await axios.get(
        `${localApiBaseUrl}/screen-title/${learningMethodId}`,
        { headers }
      );
      const screenTitles = (response?.data?.message?.screenTitle || [])
        .filter((screen) => screen?.is_visible !== false);

      if (!screenTitles.length) {
        return null;
      }

      if (!currentScreenTitleId) {
        return screenTitles[0] || null;
      }

      const currentIndex = screenTitles.findIndex(
        (screen) => Number(screen.screen_title_id) === Number(currentScreenTitleId)
      );

      if (currentIndex >= 0 && currentIndex + 1 < screenTitles.length) {
        return screenTitles[currentIndex + 1] || null;
      }

      return null;
    } catch (error) {
      console.error("Failed to resolve next screen title:", error);
      return null;
    }
  };

  const resolveLearningMethod = async (moduleId, learningMethodId) => {
    if (!moduleId || !learningMethodId) {
      return null;
    }

    try {
      const headers = {
        Authorization: `Bearer ${authToken}`,
        "Content-Type": "application/json",
      };
      const response = await axios.get(
        `${localApiBaseUrl}/learning-method/${moduleId}`,
        { headers }
      );
      const learningMethods = response?.data?.message?.learningMethods || [];
      const matchedLearningMethod = learningMethods.find(
        (method) => Number(method.learning_method_id) === Number(learningMethodId)
      );

      if (matchedLearningMethod) {
        return matchedLearningMethod;
      }

      const canonicalDayId = Number(learningMethods?.[0]?.day_id || 0);
      if (canonicalDayId && canonicalDayId !== Number(moduleId)) {
        const canonicalResponse = await axios.get(
          `${localApiBaseUrl}/learning-method/${canonicalDayId}`,
          { headers }
        );
        const canonicalLearningMethods =
          canonicalResponse?.data?.message?.learningMethods || [];
        return (
          canonicalLearningMethods.find(
            (method) =>
              Number(method.learning_method_id) === Number(learningMethodId)
          ) || null
        );
      }

      return null;
    } catch (error) {
      console.error("Failed to resolve learning method:", error);
      return null;
    }
  };

  const navigateToResolvedScreen = async ({
    moduleId,
    lessonName,
    learningMethodId,
    screenTitleId,
    advanceScreen = false,
  }) => {
    if (!moduleId && !learningMethodId) {
      navigateToLearningJourney();
      return;
    }

    const learningMethod = await resolveLearningMethod(moduleId, learningMethodId);
    const screenTitle = await resolveScreenTitle(learningMethodId, screenTitleId);
    const resolvedLessonName =
      lessonName || resolveLessonNameByModuleId(moduleId, lessonName);
    const nextScreenTitle = advanceScreen
      ? await resolveNextScreenTitle(learningMethodId, screenTitle?.screen_title_id || screenTitleId)
      : null;
    const resolvedScreenTitle = nextScreenTitle || screenTitle;
    const state = buildSectionState({
      moduleId,
      lessonName: resolvedLessonName,
      learningMethod: learningMethod || {
        learning_method_id: learningMethodId,
      },
      screenTitle: resolvedScreenTitle,
    });

    persistCurrentSection({
      moduleId,
      lessonName: resolvedLessonName,
      learningMethodId,
      screenTitleId: resolvedScreenTitle?.screen_title_id || screenTitleId,
    });

    const screenTitleName = String(resolvedScreenTitle?.title || "").trim();
    const normalizedTitle = screenTitleName.toLowerCase();

    if (
      normalizedTitle.includes("skit") ||
      normalizedTitle.includes("にほんのこうこう") ||
      normalizedTitle.includes("नाटक1_दिन") ||
      normalizedTitle.includes("नाटक")
    ) {
      navigate("/ModuleSkit", { state });
      return;
    }

    if (normalizedTitle === "quiz" || normalizedTitle === "प्रश्न और उत्तर" || normalizedTitle === "पढ़ना" || normalizedTitle === "व्याकरण और शब्दावली") {
      navigate("/take-quiz", { state });
      return;
    }

    if (
      normalizedTitle === "flash card" ||
      normalizedTitle === "flashcard" ||
      normalizedTitle === "फ्लैशकार्ड"
    ) {
      navigate("/FlashCard", { state });
      return;
    }

    if (normalizedTitle === "lecture" || normalizedTitle === "पाठ वीडियो") {
      navigate("/leacture-video", { state });
      return;
    }

    if (normalizedTitle === "writing practice" || normalizedTitle === "लिखाई का अभ्यास") {
      navigate("/PracticePage", { state });
      return;
    }

    if (normalizedTitle === "listening" || normalizedTitle === "सुनना") {
      navigate("/ModuleListening", { state });
      return;
    }

    navigate("/day-module", {
      state: {
        ModuleId: moduleId,
        unique_day_id: moduleId,
        ModuleNameName: resolvedLessonName,
        Day_Name: resolvedLessonName,
        examId: currentExamId,
        examTypes: ExamTypedata?.examTypes || [],
        selectedExamId: currentExamId,
        exams: ExamTypedata?.examTypes || [],
        learningMethodId,
        screenTitleId: resolvedScreenTitle?.screen_title_id || screenTitleId,
      },
    });
  };

  const handleGoToCurrentSection = async () => {
    if (isComingSoonStage) {
      return;
    }
    if (!latestVisitData) {
      if (
        nextSectionData?.next_day_id &&
        nextSectionData?.next_learning_method_id &&
        nextSectionData?.next_screen_title_id
      ) {
        await navigateToResolvedScreen({
          moduleId: nextSectionData.next_day_id,
          lessonName:
            nextSectionData?.learningMethod?.day_name ||
            nextSectionData?.lessonName ||
            nextSectionData?.lesson ||
            nextSectionData?.dayName ||
            homeLessonLabel ||
            formatLessonLabel(nextSectionData.next_day_id),
          learningMethodId:
            nextSectionData.next_learning_method_id ||
            nextSectionData?.learningMethod?.learning_method_id,
          screenTitleId: nextSectionData.next_screen_title_id,
        });
        return;
      }

      navigateToLearningJourney({ focus: "current" });
      return;
    }

    const openedTime = latestVisitData?.visitedAt ? new Date(latestVisitData.visitedAt).getTime() : 0;
    const finishedTime = latestVisitData?.finished_at ? new Date(latestVisitData.finished_at).getTime() : 0;
    const isFinishedAfterOpened = latestVisitData?.finish && (
      finishedTime > 0 ? (finishedTime >= openedTime) : true
    );

    if (isFinishedAfterOpened && nextSectionData && nextSectionData.next_day_id) {
      await navigateToResolvedScreen({
        moduleId: nextSectionData.next_day_id,
        lessonName:
          nextSectionData?.learningMethod?.day_name ||
          nextSectionData?.lessonName ||
          nextSectionData?.lesson ||
          nextSectionData?.dayName ||
          homeLessonLabel ||
          formatLessonLabel(nextSectionData.next_day_id),
        learningMethodId:
          nextSectionData.next_learning_method_id ||
          nextSectionData?.learningMethod?.learning_method_id,
        screenTitleId:
          nextSectionData.next_screen_title_id ||
          nextSectionData.screen?.screen_title_id,
      });
      return;
    }

    navigateToResolvedScreen({
      moduleId: latestVisitData.unique_day_id || latestVisitData.id,
      lessonName: homeLessonLabel,
      learningMethodId: latestVisitData.learning_method_id,
      screenTitleId: latestVisitData.screen_title_id,
    });
  };

  const handleMoveToNextSection = async () => {
    if (isComingSoonStage) {
      return;
    }
    if (!latestVisitData) {
      if (
        nextSectionData?.next_day_id &&
        nextSectionData?.next_learning_method_id &&
        nextSectionData?.next_screen_title_id
      ) {
        await navigateToResolvedScreen({
          moduleId: nextSectionData.next_day_id,
          lessonName:
            nextSectionData?.learningMethod?.day_name ||
            nextSectionData?.lessonName ||
            nextSectionData?.lesson ||
            nextSectionData?.dayName ||
            homeLessonLabel ||
            formatLessonLabel(nextSectionData.next_day_id),
          learningMethodId:
            nextSectionData.next_learning_method_id ||
            nextSectionData?.learningMethod?.learning_method_id,
          screenTitleId: nextSectionData.next_screen_title_id,
        });
        return;
      }

      navigateToLearningJourney({ focus: "next" });
      return;
    }

    if (nextSectionData?.screen?.screen_title_id) {
      const backendLessonName =
        nextSectionData?.learningMethod?.day_name ||
        nextSectionData?.lessonName ||
        nextSectionData?.lesson ||
        nextSectionData?.dayName ||
        homeLessonLabel ||
        `Lesson ${nextSectionData?.next_day_id || ""}`;

      await navigateToResolvedScreen({
        moduleId: nextSectionData?.next_day_id || latestVisitData.unique_day_id || latestVisitData.id,
        lessonName: backendLessonName,
        learningMethodId:
          nextSectionData?.next_learning_method_id ||
          nextSectionData?.learningMethod?.learning_method_id ||
          latestVisitData.learning_method_id,
        screenTitleId:
          nextSectionData?.next_screen_title_id ||
          nextSectionData?.screen?.screen_title_id,
      });
      return;
    }

    const currentLessonRowId = Number(latestVisitData.unique_day_id || latestVisitData.id || 0);
    const currentDayRecord = resolveDayRecordByModuleId(currentLessonRowId);
    const currentLessonDayNumber = Number(
      currentDayRecord?.day_id || currentDayRecord?.id || currentLessonRowId
    );
    const currentLessonName =
      currentDayRecord?.day_name || homeLessonLabel || `Lesson ${currentLessonRowId}`;
    const currentLearningMethodId = latestVisitData.learning_method_id;
    const currentScreenTitleId = latestVisitData.screen_title_id;
    const currentLearningMethods = await fetchLearningMethodsForDayRow(
      currentLessonRowId
    );
    const currentMethodIndex = currentLearningMethods.findIndex(
      (method) =>
        Number(method?.learning_method_id) === Number(currentLearningMethodId)
    );

    const nextScreenInCurrentLesson = await resolveNextScreenTitle(
      currentLearningMethodId,
      currentScreenTitleId
    );

    if (nextScreenInCurrentLesson) {
      await navigateToResolvedScreen({
        moduleId: currentLessonRowId,
        lessonName: currentLessonName,
        learningMethodId: currentLearningMethodId,
        screenTitleId: nextScreenInCurrentLesson.screen_title_id,
      });
      return;
    }

    if (
      currentMethodIndex !== -1 &&
      currentMethodIndex < currentLearningMethods.length - 1
    ) {
      const nextLearningMethod = currentLearningMethods[currentMethodIndex + 1];
      const nextScreen = await resolveScreenTitle(
        nextLearningMethod.learning_method_id
      );

      if (nextScreen) {
        await navigateToResolvedScreen({
          moduleId: currentLessonRowId,
          lessonName: currentLessonName,
          learningMethodId: nextLearningMethod.learning_method_id,
          screenTitleId: nextScreen.screen_title_id,
        });
        return;
      }
    }

    const nextLessonDayNumber = currentLessonDayNumber
      ? currentLessonDayNumber + 1
      : currentLessonRowId + 1;

    if (nextLessonDayNumber) {
      const nextLessonResponse = await axios.get(
        `https://api.japaking.online/api/exam-types/days/by-day-id/${nextLessonDayNumber}`,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
            "Content-Type": "application/json",
          },
        }
      );
      const nextLessonName =
        nextLessonResponse?.data?.message?.day?.day_name ||
        nextLessonResponse?.data?.message?.day_name ||
        resolveLessonNameByModuleId(nextLessonDayNumber, "") ||
        formatLessonLabel(nextLessonDayNumber);

      const nextLearningMethods = await fetchLearningMethodsForDayRow(
        nextLessonDayNumber
      );
      const nextLearningMethod = nextLearningMethods[0] || null;
      const nextScreen = nextLearningMethod
        ? await resolveScreenTitle(nextLearningMethod.learning_method_id)
        : null;

      if (nextLearningMethod && nextScreen) {
        await navigateToResolvedScreen({
          moduleId: nextLessonDayNumber,
          lessonName: nextLessonName,
          learningMethodId: nextLearningMethod.learning_method_id,
          screenTitleId: nextScreen.screen_title_id,
        });
        return;
      }
    }

    if (nextSectionData?.next_day_id) {
      const fallbackLessonName =
        resolveLessonNameByModuleId(nextSectionData.next_day_id, currentLessonName) ||
        currentLessonName;
      await navigateToResolvedScreen({
        moduleId: nextSectionData.next_day_id,
        lessonName: fallbackLessonName,
        learningMethodId:
          nextSectionData?.next_learning_method_id ||
          nextSectionData?.learningMethod?.learning_method_id ||
          currentLearningMethodId ||
          null,
        screenTitleId:
          nextSectionData?.next_screen_title_id ||
          nextSectionData?.screen?.screen_title_id ||
          null,
      });
      return;
    }

    navigateToLearningJourney({ focus: "next" });
  };

  const studyTodayMinutes = Math.round(completedHours * 60);
  const todayStudyLabel = `${Math.max(studyTodayMinutes, 0)} min`;
  const yesterdayStudyLabel = localStorage.getItem("yesterdayStudyTime") || "0 min";
  const selectedExamId_New = selectedExamId || VisitedCountData?.message?.exam_id;
  const storedSelectedExamId = Number(localStorage.getItem("selectedExamId") || 0);
  const n5ExamId = ExamTypedata?.examTypes?.find((exam) => exam.exam_type === "N5")?.exam_id;
  const n4ExamId = ExamTypedata?.examTypes?.find((exam) => exam.exam_type === "N4")?.exam_id;
  const n3ExamId = ExamTypedata?.examTypes?.find((exam) => exam.exam_type === "N3")?.exam_id;
  const baseExamId = Number(
    storedSelectedExamId ||
    selectedExamId_New ||
    selectedExamId ||
    n5ExamId ||
    ExamTypedata?.examTypes?.[0]?.exam_id ||
    1
  );
  const mapExamIdToStageLabel = (examId) => {
    const normalizedExamId = Number(examId);
    if (normalizedExamId === 3) {
      return "N3 coming soon";
    }
    if (normalizedExamId === 2) {
      return "N4";
    }
    return "N5";
  };
  const extractLessonLabel = (value) => {
    const match = String(value || "").match(/(?:Lesson|पाठ)\s+(\d+)/i);
    return match ? `${isHindiLanguage ? "पाठ" : "Lesson"} ${match[1]}` : "";
  };
  const currentExamPassIds = Array.isArray(username?.message?.userDetails?.current_exam_pass_id)
    ? username.message.userDetails.current_exam_pass_id.map((id) => Number(id))
    : [];
  const hasN3OrJftBasic = currentExamPassIds.some((id) => id === 2 || id === 3);
  const hasN5 = currentExamPassIds.includes(1);
  const stageLabel = latestVisitData?.exam_id
    ? mapExamIdToStageLabel(latestVisitData.exam_id)
    : hasN3OrJftBasic
      ? "N3 coming soon"
      : hasN5
        ? "N4"
        : "N5";
  const isComingSoonStage = stageLabel === "N3 coming soon";
  const stageNavigationExamId =
    ExamTypedata?.examTypes?.find((exam) => exam.exam_type === (hasN3OrJftBasic ? "N3" : hasN5 ? "N4" : "N5"))?.exam_id ||
    baseExamId;
  const stageNavigationExamType =
    ExamTypedata?.examTypes?.find((exam) => Number(exam.exam_id) === Number(stageNavigationExamId))?.exam_type ||
    (hasN3OrJftBasic ? "N3" : hasN5 ? "N4" : "N5");
  const currentExamId = Number(latestVisitData?.exam_id || latestVisitData?.lessonDetails?.exam_id || stageNavigationExamId);
  const currentExamType =
    ExamTypedata?.examTypes?.find((exam) => Number(exam.exam_id) === Number(currentExamId))?.exam_type ||
    mapExamIdToStageLabel(currentExamId).replace(" coming soon", "") ||
    localStorage.getItem("selectedExamType") ||
    "N5";
  const navigationExamId = latestVisitData ? currentExamId : stageNavigationExamId;
  const navigationExamType = latestVisitData ? currentExamType : stageNavigationExamType;
  const lessonLabel =
    isComingSoonStage
      ? "Coming Soon"
      : localizeLessonText(extractLessonLabel(homeSectionLabel) || homeLessonLabel) ||
      formatLessonLabel(storedCurrentModule?.day_id || storedCurrentModule?.id) ||
      `${isHindiLanguage ? "पाठ" : "Lesson"} ${VisitedCountData?.message?.count || 1}`;
  const sectionLabel = isComingSoonStage
    ? "Coming Soon"
    : localizeSectionText(homeSectionLabel) || (isHindiLanguage ? "हिस्सा" : "Section");

  // const [ExamLevelId, setExamLevelId] = useState(null);
  // console.log("ExamLevelId:", ExamLevelId);
  const handleExamLevelData = async selectedExamId => {
    setIsLoading(true);
    try {

      const response = await axios.put(
        `https://api.japaking.online/api/users/user-details`,
        { exam_id: selectedExamId },
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
            'Content-Type': 'application/json',
          },
        },
      );

      console.log('Level updated successfully:', response?.data);
      // fetchsetExamLevelIdData();
      // getVisitedCountDataData();
      // setischooselevel(false); // Close the level modal or update state
      // You can add navigation here if required, e.g.:
      // navigation.navigate('NextScreen');
    } catch (error) {
      console.error('Error updating level:', error);
      setError(error);
      if (error.response?.status === 401) {
        console.log('Authentication error. Redirecting to Login.');
        // Uncomment to navigate
        // navigation.navigate('Login');
      } else {
        alert('Error', 'Something went wrong. Please try again.');
      }
    } finally {
      setIsLoading(false); // End the loading state
    }
  };
  // const fetchsetExamLevelIdData = async () => {
  //   try {

  //     // console.log(authToken, 'authToken Context API');
  //     const response = await axios.get(`https://api.japaking.online/api/users`, {
  //       headers: {
  //         'x-auth': authToken,
  //         'Content-Type': 'application/json',
  //       },
  //     });

  //     if (response.ok) {
  //       const data = await response.json();
  //       setExamLevelId(data);
  //       console.log("data", data);

  //     } else {
  //       console.error('Failed to fetch load data');
  //     }
  //   } catch (error) {
  //     console.error('Error fetching Profile data Auth:', error);
  //   }
  // };
  const ExamConvertID = username?.message?.userDetails?.exam_id;
  console.log("ExamConvertID:", ExamConvertID);

  const getVisitedCountData = async (examId, showLocalLoading = true) => {
    try {
      if (showLocalLoading) {
        setIsLoading(true); // Show loading state
      }

      const response = await axios.get(
        `https://api.japaking.online/api/user-visits/count?examId=${examId}`,
        {
          headers: {
            'x-auth': `Bearer ${authToken}`,
            'Authorization': `Bearer ${authToken}`,
            'Content-Type': 'application/json',
          },
        },
      );

      setVisitedCountData(response?.data); // Update state with fetched data
    } catch (error) {
      if (error.response) {
        console.error('API Error Check Data:', error.response.data);
      } else {
        console.error('Visited Count Error:', error);
      }
    } finally {
      if (showLocalLoading) {
        setIsLoading(false); // Hide loading state
      }
    }
  };

  const fetchLatestGroupMessage = async () => {
    if (!authToken || !senderId) return;
    try {
      const response = await axios.get(
        `https://api.japaking.online/api/chat-rt/history?studentId=${senderId}&chatType=group`,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (response?.data?.success && Array.isArray(response?.data?.message?.history)) {
        const history = response.data.message.history;
        const groupMessages = history.filter(
          (msg) => Number(msg.sender_id || msg.sender_user?.user_id || 0) !== Number(senderId)
        );
        if (groupMessages.length > 0) {
          const latest = groupMessages[groupMessages.length - 1];
          setLatestGroupMessage(latest);
        } else {
          setLatestGroupMessage(null);
        }
      }
    } catch (error) {
      console.error("Failed to fetch latest group message:", error);
    }
  };

  const renderMessageTextWithLinks = (text) => {
    if (!text) return "";
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    return text.split("\n").map((line, lineIdx) => {
      const parts = line.split(urlRegex);
      const renderedLine = parts.map((part, partIdx) => {
        if (part.match(urlRegex)) {
          return (
            <a
              key={`part-${partIdx}`}
              href={part}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#0056b3", textDecoration: "underline", wordBreak: "break-all" }}
              onClick={(e) => e.stopPropagation()}
            >
              {part}
            </a>
          );
        }
        return part;
      });
      return (
        <React.Fragment key={`line-${lineIdx}`}>
          {renderedLine}
          {lineIdx < text.split("\n").length - 1 && <br />}
        </React.Fragment>
      );
    });
  };

  const formatMsgTimeAndSender = (msg) => {
    if (!msg) return "";
    let timeStr = "";
    try {
      const date = new Date(msg.sent_at);
      const yyyy = date.getFullYear();
      const mm = String(date.getMonth() + 1).padStart(2, '0');
      const dd = String(date.getDate()).padStart(2, '0');
      const hh = String(date.getHours()).padStart(2, '0');
      const min = String(date.getMinutes()).padStart(2, '0');
      timeStr = `${yyyy}/${mm}/${dd} ${hh}:${min}`;
    } catch {
      timeStr = "";
    }
    const role = msg?.sender_role?.role_name || msg?.sender_user?.role?.role_name || msg?.role?.role_name || "Staff";
    return `${timeStr} ${role}`;
  };

  const handleGoToGroupChat = () => {
    navigate('/chat-with-staff?chatType=group');
  };

  useEffect(() => {
    if (authToken && senderId) {
      fetchLatestGroupMessage();
    }
  }, [authToken, senderId]);

  useEffect(() => {
    if (!authToken || !senderId) return;

    const socketUrl = process.env.REACT_APP_SOCKET_URL || process.env.REACT_APP_BASE_URL || "https://api.japaking.online";
    const socket = io(socketUrl, {
      transports: ["websocket"],
      withCredentials: true,
    });

    socket.on("connect", () => {
      socket.emit("join", { user_id: senderId });
    });

    const handleNewMessage = (chat) => {
      const chatSenderId = Number(chat?.sender_id || chat?.sender_user?.user_id || 0);
      const chatReceiverId = Number(chat?.receiver_id || chat?.receiver_user?.user_id || 0);
      const isCurrentUserChat = chatSenderId === Number(senderId) || chatReceiverId === Number(senderId);

      if (chat.chat_type === "group" && isCurrentUserChat && chatSenderId !== Number(senderId)) {
        setLatestGroupMessage(chat);
      }
    };

    socket.on("chat:new", handleNewMessage);
    socket.on("chat:sent", handleNewMessage);

    return () => {
      socket.disconnect();
    };
  }, [authToken, senderId]);

  const MessagePrint = () => {
    alert('Please Choose your study Level');
  };
  // useEffect(() => {
  //   GetHours();
  // }, []);

  // console.log(Learningdata,"setLearningData Home")

  // console.log(VisitedCountData, "VisitedCountData Check Data");
  // console.log(marker?.length, "marker Home")
  const visited_ID = VisitedCountData?.message?.exam_id;
  console.log("visited_ID:", visited_ID);
  console.log("VisitedCountData:", VisitedCountData);
  console.log("VisitedCountData.message:", VisitedCountData?.message);
  console.log("VisitedCountData.message.count:", VisitedCountData?.message?.count);
  console.log("VisitedCountData.message.totalCount:", VisitedCountData?.message?.totalCount);
  console.log("overlayText:", overlayText);

  useEffect(() => {
    const fetchHomeProgress = async () => {
      if (!authToken || !currentExamId) {
        setHomeLoading(false);
        return;
      }

      setHomeLoading(true);

      try {
        const headers = {
          Authorization: `Bearer ${authToken}`,
          "Content-Type": "application/json",
        };

        const latestResponse = await axios.get(
          `https://api.japaking.online/api/user-visits/latest-visited-status`,
          { headers }
        );

        const latestVisit = latestResponse?.data || null;

        const latestVisitExamId = Number(
          latestVisit?.exam_id ||
          latestVisit?.lessonDetails?.exam_id ||
          latestVisit?.learningMethodDetails?.exam_id ||
          currentExamId
        );

        const [nextResponse, daysResponse] = await Promise.all([
          axios.get(
            `https://api.japaking.online/api/user-visits/next-section?examId=${latestVisitExamId}`,
            { headers }
          ),
          axios.get(
            `${localApiBaseUrl}/exam-types/days/${latestVisitExamId}`,
            { headers }
          ),
          getVisitedCountData(latestVisitExamId, false),
        ]);

        const days = daysResponse?.data?.message?.days || [];
        setExamDays(days);

        const nextSection = nextResponse?.data || null;
        setLatestVisitData(latestVisit);
        setNextSectionData(nextSection);

        let activeDayId = null;
        let activeLearningMethodId = null;
        let activeScreenTitleId = null;
        let resolvedLessonLabel = "";

        if (nextSection && nextSection.next_day_id) {
          // Compare finished_at vs visitedAt timestamps to determine true finish status
          const lvOpenedTime = latestVisit?.visitedAt ? new Date(latestVisit.visitedAt).getTime() : 0;
          const lvFinishedTime = latestVisit?.finished_at ? new Date(latestVisit.finished_at).getTime() : 0;
          const lvIsFinishedAfterOpened = latestVisit?.finish && (
            lvFinishedTime > 0 ? (lvFinishedTime >= lvOpenedTime) : true
          );

          if (latestVisit && !lvIsFinishedAfterOpened) {
            activeDayId = latestVisit.unique_day_id || latestVisit.id;
            activeLearningMethodId = latestVisit.learning_method_id;
            activeScreenTitleId = latestVisit.screen_title_id;
            resolvedLessonLabel =
              latestVisit?.lessonDetails?.day_name ||
              latestVisit?.lesson ||
              latestVisit?.Lesson ||
              "";
          } else {
            activeDayId = nextSection.next_day_id;
            activeLearningMethodId = nextSection.next_learning_method_id || nextSection.learningMethod?.learning_method_id;
            activeScreenTitleId = nextSection.next_screen_title_id || nextSection.screen?.screen_title_id;
            resolvedLessonLabel =
              nextSection?.learningMethod?.day_name ||
              nextSection?.lessonName ||
              nextSection?.lesson ||
              nextSection?.dayName ||
              "";
          }
        } else if (latestVisit) {
          activeDayId = latestVisit.unique_day_id || latestVisit.id;
          activeLearningMethodId = latestVisit.learning_method_id;
          activeScreenTitleId = latestVisit.screen_title_id;
          resolvedLessonLabel =
            latestVisit?.lessonDetails?.day_name ||
            latestVisit?.lesson ||
            latestVisit?.Lesson ||
            "";
        }

        const latestDayId = Number(activeDayId || latestVisit?.id || 0);
        const latestLearningMethodId = Number(activeLearningMethodId || latestVisit?.learning_method_id || 0);
        const latestScreenTitleId = Number(activeScreenTitleId || latestVisit?.screen_title_id || 0);

        const matchedDay = days.find(
          (d) => Number(d?.id) === latestDayId || Number(d?.day_id) === latestDayId
        );
        const resolvedDayName = matchedDay?.day_name || resolvedLessonLabel || formatLessonLabel(latestDayId);
        setHomeLessonLabel(resolvedDayName);

        if (latestDayId && latestLearningMethodId && latestScreenTitleId) {
          try {
            const learningResponse = await axios.get(
              `${localApiBaseUrl}/learning-method/${latestDayId}`,
              { headers }
            );
            let learningMethods =
              learningResponse?.data?.message?.learningMethods || [];

            const canonicalDayId = Number(learningMethods?.[0]?.day_id || 0);
            if (canonicalDayId && canonicalDayId !== latestDayId) {
              const canonicalResponse = await axios.get(
                `${localApiBaseUrl}/learning-method/${canonicalDayId}`,
                { headers }
              );
              learningMethods = canonicalResponse?.data?.message?.learningMethods || learningMethods;
            }

            const currentLearningMethod = learningMethods.find(
              (method) =>
                Number(method.learning_method_id) ===
                latestLearningMethodId
            );
            const fallbackMethodType =
              currentLearningMethod?.method_type ||
              learningMethods?.[0]?.method_type ||
              latestVisit?.method_type ||
              currentLearningMethod?.desc ||
              learningMethods?.[0]?.desc ||
              "";

            const screenResponse = await axios.get(
              `${localApiBaseUrl}/screen-title/${latestLearningMethodId}`,
              { headers }
            );
            const screenTitles = screenResponse?.data?.message?.screenTitle || [];
            const matchedScreen = screenTitles.find(
              (screen) =>
                Number(screen.screen_title_id) === latestScreenTitleId
            );
            const showNextOpenedTime = latestVisit?.visitedAt ? new Date(latestVisit.visitedAt).getTime() : 0;
            const showNextFinishedTime = latestVisit?.finished_at ? new Date(latestVisit.finished_at).getTime() : 0;
            const showNextIsFinished = latestVisit?.finish && (
              showNextFinishedTime > 0 ? (showNextFinishedTime >= showNextOpenedTime) : true
            );
            const showNext = showNextIsFinished && nextSection && nextSection.next_day_id;
            const sectionMethodLabel = showNext
              ? (nextSection?.learningMethod?.method_type ||
                 currentLearningMethod?.method_type ||
                 currentLearningMethod?.desc ||
                 learningMethods?.[0]?.method_type ||
                 learningMethods?.[0]?.desc ||
                 fallbackMethodType ||
                 "")
              : (latestVisit?.learningMethodDetails?.method_type ||
                 currentLearningMethod?.method_type ||
                 latestVisit?.method_type ||
                 learningMethods?.[0]?.method_type ||
                 currentLearningMethod?.desc ||
                 learningMethods?.[0]?.desc ||
                 fallbackMethodType ||
                 "");
            const sectionScreenLabel = showNext
              ? (nextSection?.screen?.title ||
                 nextSection?.screen?.subtitle ||
                 matchedScreen?.title ||
                 matchedScreen?.subtitle ||
                 "")
              : (latestVisit?.sectionDetails?.title ||
                 latestVisit?.sectionDetails?.subtitle ||
                 matchedScreen?.title ||
                 matchedScreen?.subtitle ||
                 "");
            setHomeSectionLabel(
              (showNext ? null : (latestVisit?.section || latestVisit?.Section)) ||
              composeSectionLabel(
                localizeLessonText(resolvedDayName),
                sectionMethodLabel,
                sectionScreenLabel
              )
            );
          } catch (error) {
            const fbOpenedTime = latestVisit?.visitedAt ? new Date(latestVisit.visitedAt).getTime() : 0;
            const fbFinishedTime = latestVisit?.finished_at ? new Date(latestVisit.finished_at).getTime() : 0;
            const fbIsFinished = latestVisit?.finish && (
              fbFinishedTime > 0 ? (fbFinishedTime >= fbOpenedTime) : true
            );
            const showNext = fbIsFinished && nextSection && nextSection.next_day_id;
            setHomeSectionLabel(
              (showNext ? null : (latestVisit?.section || latestVisit?.Section)) ||
              localizeSectionText(resolvedDayName)
            );
          }
        } else {
          const elOpenedTime = latestVisit?.visitedAt ? new Date(latestVisit.visitedAt).getTime() : 0;
          const elFinishedTime = latestVisit?.finished_at ? new Date(latestVisit.finished_at).getTime() : 0;
          const elIsFinished = latestVisit?.finish && (
            elFinishedTime > 0 ? (elFinishedTime >= elOpenedTime) : true
          );
          const showNext = elIsFinished && nextSection && nextSection.next_day_id;
          setHomeSectionLabel(
            (showNext ? null : (latestVisit?.section || latestVisit?.Section)) ||
            localizeSectionText(resolvedDayName) ||
            ""
          );
        }
      } catch (error) {
        console.error("Failed to fetch home progress:", error);
      } finally {
        setHomeLoading(false);
      }
    };

    fetchHomeProgress();
  }, [authToken, currentExamId, marker]);

  useEffect(() => {
    if (ExamTypedata?.examTypes?.length > 0) {
      const storedExam =
        ExamTypedata.examTypes.find((exam) => Number(exam.exam_id) === Number(storedSelectedExamId)) ||
        ExamTypedata.examTypes.find((exam) => Number(exam.exam_id) === Number(selectedExamId)) ||
        ExamTypedata.examTypes.find((exam) => exam.exam_type === "N5") ||
        ExamTypedata.examTypes[0];

      if (storedExam) {
        setActiveTab(storedExam.exam_type);
        setSelectedExamId(storedExam.exam_id);
        setSelectedExamType(storedExam.exam_type);
        localStorage.setItem("selectedExamId", String(storedExam.exam_id));
        localStorage.setItem("selectedExamType", storedExam.exam_type);
      }
    }
  }, [ExamTypedata, selectedExamId, storedSelectedExamId]);

  if (homeLoading) {
    return (
      <div className="home-v2-page home-v2-loading-page">
        <div className="home-v2-loading-shell" aria-live="polite" aria-busy="true">
          <Spinner animation="border" role="status" className="home-v2-loading-spinner" />
          <p className="home-v2-loading-text">{homeText.loading}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="home-v2-page">
      <div className="home-v2-shell">
        <div className="header_inner">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div style={{ display: 'inline-block', float: 'left', marginTop: '8px' }}></div>
                <h2>JapaKing</h2>
                <ChatBubbleOutlineIcon
                  onClick={() => navigate('/chat-with-staff')}
                  className="logo_1"
                  style={{ cursor: 'pointer', color: '#ffc0cb' }}
                />
              </div>
            </div>
          </div>
        </div>

        <section className="home-v2-card home-v2-now-studying">
          <h2>{homeText.nowStudying}</h2>

          <div className="home-v2-info-grid">
            <div className="home-v2-info-row">
              <span>{homeText.stage}</span>
              <strong>{stageLabel}</strong>
            </div>
            <div className="home-v2-info-row">
              <span>{homeText.lesson}</span>
              <strong>{lessonLabel}</strong>
            </div>
            <div className="home-v2-info-row home-v2-info-row-section">
              <span>{homeText.section}</span>
              <strong>{sectionLabel}</strong>
            </div>
          </div>

          <button type="button" className="home-v2-button home-v2-button-primary" style={{ backgroundColor: 'grey', color: 'white', border: 'none' }} onClick={handleGoToCurrentSection} disabled={isComingSoonStage}>
            {homeText.goToCurrentSection}
          </button>

          <button type="button" className="home-v2-button home-v2-button-secondary" style={{ backgroundColor: 'black', color: 'white', border: 'none' }} onClick={handleMoveToNextSection} disabled={isComingSoonStage}>
            {homeText.moveToNextSection}
          </button>
        </section>

        {latestGroupMessage && (
          <section
            className="home-v2-card home-v2-supervisor-chat"
            style={{ marginTop: "18px", cursor: "pointer" }}
            onClick={handleGoToGroupChat}
          >
            <h2 style={{ fontSize: "22px", fontWeight: "700", color: "#151515", marginBottom: "16px", textAlign: "center" }}>
              {homeText.chatFromSupervisor}
            </h2>
            <div style={{ padding: "16px", border: "1px solid #dfdfe4", borderRadius: "14px", background: "#ffffff", textAlign: "left" }}>
              <div style={{ fontSize: "16px", lineHeight: "1.5", color: "#1a1a1a", whiteSpace: "pre-wrap", fontWeight: "500", textAlign: "left" }}>
                {renderMessageTextWithLinks(latestGroupMessage.message)}
              </div>
              <div style={{ textAlign: "left", fontSize: "14px", color: "#787878", marginTop: "16px", fontWeight: "600" }}>
                {formatMsgTimeAndSender(latestGroupMessage)}
              </div>
            </div>
          </section>
        )}

        <section className="home-v2-card home-v2-study-time">
          <h2>{homeText.studyTime}</h2>
          <div style={{ textAlign: "center", padding: "10px 0", color: "#787878", fontWeight: "600", fontSize: "16px" }}>
            {homeText.trackStudyTimeComingSoon}
          </div>
        </section>
      </div>

      <FooterNav authToken={AuthToken1} translate={Translate} />
    </div>
  );
}

export default Home;
